import React from 'react';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import MultiNotifsMenuContainer from '../container-multi-notifs-menu';
import { IconContainer } from '../container-multi-notifs-menu/styled';
import { SidebarIcon } from '../view-sidebar/styled';
import { NotificationOverlayContentWrap, NotificationOverlayContentWrapper, NotificationOverlayTitle, NotificationOverlayTitleWrap, NotificationOverlayWrapper } from './styled';
import PropTypes from 'prop-types';
const NotificationsContainerOverlay = _ref => {
  let {
    onClose,
    animation
  } = _ref;
  return /*#__PURE__*/React.createElement(NotificationOverlayWrapper, null, /*#__PURE__*/React.createElement(NotificationOverlayContentWrapper, {
    animation: animation
  }, /*#__PURE__*/React.createElement(NotificationOverlayTitleWrap, null, /*#__PURE__*/React.createElement(IconContainer, {
    onClick: onClose
  }, /*#__PURE__*/React.createElement(SidebarIcon, {
    size: "3x",
    icon: faArrowLeft
  })), /*#__PURE__*/React.createElement(NotificationOverlayTitle, null, "Notifications")), /*#__PURE__*/React.createElement(NotificationOverlayContentWrap, null, /*#__PURE__*/React.createElement(MultiNotifsMenuContainer, {
    isMobile: true
  }))));
};
NotificationsContainerOverlay.propTypes = {
  animation: PropTypes.string.isRequired
};
export default NotificationsContainerOverlay;